import { config, environmentConfig } from '../config'

const { apiUrl } = environmentConfig[config.environment]

export const apiConfig = {
  authUrl: `${apiUrl}/mea-auth`,
  backEndUrl: `${apiUrl}/mea-api`,
}
